"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _notify = _interopRequireDefault(require("./notify.js"));

var _service = _interopRequireDefault(require("./service.js"));

var _serviceClass = _interopRequireDefault(require("./serviceClass.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  /**
   *  @description Cancella le variabili di sessione e redirige al login
   *  @param {Object} component : componente di riferimento
   */
  fn_logout: function fn_logout(component) {
    localStorage.clear();
    this.fn_redirectToLogin(component);
  },

  /**
   *  @description Cancella le variabili di sessione e redirige al login
   */
  fn_clearSession: function fn_clearSession() {
    localStorage.clear();
  },

  /**
   * @description Blocca la schermata utente
   */
  fn_lock: function fn_lock() {
    localStorage.setItem("lockScreen", true);
    window.location.reload();
  },

  /**
   * @description Redirige alla home page del sito
   * @param {Object} component : componente di riferimento
   */
  fn_redirectToHome: function fn_redirectToHome(component) {
    fetch(process.env.PUBLIC_URL + "/config.json").then(function (response) {
      return response.json();
    }).then(function (response) {
      var home = response.homePage;
      component.props.history.push(home);
    });
  },

  /**
   * @description Redirige alla pagina di login
   * @param {Object} component : componente di riferimento
   */
  fn_redirectToLogin: function fn_redirectToLogin(component) {
    if (component.props !== undefined) {
      fetch(process.env.PUBLIC_URL + "/config.json").then(function (response) {
        return response.json();
      }).then(function (response) {
        var loginPage = response.loginPage;
        component.props.history.push(loginPage);
      });
    } else {
      window.location.reload();
    }
  },

  /**
   * @description Sblocca la schermata utente se la password inserita è corretta
   * @param {Object} component : componente di riferimento
   * @param {String} password : password inserita
   */
  fn_unlock: function fn_unlock(component, password) {
    if (password === "") {
      _notify.default.fn_error("Inserire una password");
    } else if (password === localStorage.getItem("password")) {
      localStorage.setItem("lockScreen", false);
      this.fn_redirectToHome(component);
    } else {
      _notify.default.fn_error("La password inserita è errata.");
    }
  },

  /**
   * @description Dati i dati di risposta dal server salva i dati in sessione
   */
  fn_saveSession: function fn_saveSession(serverResponse) {
    var loginGestionale = localStorage.getItem("loginGestionale");
    var loginIdCliente = localStorage.getItem("loginIdCliente");
    var hideMenu = localStorage.getItem("hideMenu");
    var getUsername = localStorage.getItem("getUsername");
    var getPassword = localStorage.getItem("getPassword");
    var getHomePage = localStorage.getItem("getHomePage");
    localStorage.clear();
    localStorage.setItem("permessi", JSON.stringify(serverResponse["permessi"]));
    localStorage.setItem("funzionalita", JSON.stringify(serverResponse["funzionalita"]));
    localStorage.setItem("ambito", serverResponse["ambito"]);
    localStorage.setItem("menu", JSON.stringify(serverResponse["menu"]));
    localStorage.setItem("tokenKey", serverResponse["tokenKey"]);
    localStorage.setItem("utenteId", serverResponse["utenteId"]);
    localStorage.setItem("accessoId", serverResponse["accessoId"]);
    localStorage.setItem("registryId", serverResponse["registryId"]);
    localStorage.setItem("utenteNome", serverResponse["utenteNome"]);
    localStorage.setItem("utenteEmail", serverResponse["utenteEmail"]);
    localStorage.setItem("utenteContatto", serverResponse["utenteContatto"]);
    localStorage.setItem("username", serverResponse["username"]);
    localStorage.setItem("password", serverResponse["password"]);
    localStorage.setItem("logo", JSON.stringify(serverResponse["logo"]));
    localStorage.setItem("lockScreen", false);
    localStorage.setItem("loginGestionale", loginGestionale);
    localStorage.setItem("loginIdCliente", loginIdCliente);
    localStorage.setItem("hideMenu", hideMenu);
    localStorage.setItem("getUsername", getUsername);
    localStorage.setItem("getPassword", getPassword);
    localStorage.setItem("getHomePage", getHomePage);
    localStorage.setItem('setupTime', new Date().getTime());
  },
  fn_saveSessionWebService: function fn_saveSessionWebService() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var config;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _serviceClass.default.getConfig();

            case 2:
              config = _context.sent;
              //let token=await ServiceClass.generateToken();           
              //localStorage.setItem("tokenKeyGenerate", token);
              localStorage.setItem("webServiceUrl", config.webService);
              localStorage.setItem("applicationCode", config.codiceApplicazione);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * @description Setta le variabili get in sessione
   * - GET:
   *       gestionale
   *       cliente
   *       username
   *       password
   *       hideMenu     
   * @param {props} props
   */
  fn_saveSessionGetPost: function fn_saveSessionGetPost(props) {
    // const queryString = require('query-string');
    // let queryStringParam = queryString.parse(props.location.search);  
    // if(queryStringParam["gestionale"]!=undefined){
    //     localStorage.setItem("loginGestionale", queryStringParam["gestionale"]);
    // }        
    // else{
    //     localStorage.setItem("loginGestionale", "");
    // }
    // if(queryStringParam["cliente"]!=undefined){
    //     localStorage.setItem("loginIdCliente", queryStringParam["cliente"]);
    // }        
    // else{
    //     localStorage.setItem("loginIdCliente", "");
    // }
    // if(queryStringParam["username"]!=undefined){
    //     localStorage.setItem("getUsername", queryStringParam["username"]);
    // }        
    // else{
    //     localStorage.setItem("getUsername", "");
    // }
    // if(queryStringParam["password"]!=undefined){
    //     localStorage.setItem("getPassword", queryStringParam["password"]);
    // }        
    // else{
    //     localStorage.setItem("getPassword", "");
    // }
    // this.fn_setHomePage(props);
    // if(queryStringParam["hideMenu"]!=undefined){
    //     localStorage.setItem("hideMenu", queryStringParam["hideMenu"]);
    // }        
    // else{
    //     localStorage.setItem("hideMenu", "");
    // }

    /*** 239989 ***/
    var searchParams = new URLSearchParams(props.location.search);

    if (searchParams.get('gestionale') !== null) {
      localStorage.setItem("loginGestionale", searchParams.get('gestionale'));
    } else {
      localStorage.setItem("loginGestionale", "");
    }

    if (searchParams.get('cliente') !== null) {
      localStorage.setItem("loginIdCliente", searchParams.get('cliente'));
    } else {
      localStorage.setItem("loginIdCliente", "");
    }

    if (searchParams.get('username') !== null) {
      localStorage.setItem("getUsername", searchParams.get('username'));
    } else {
      localStorage.setItem("getUsername", "");
    }

    if (searchParams.get('password') !== null) {
      localStorage.setItem("getPassword", searchParams.get('password'));
    } else {
      localStorage.setItem("getPassword", "");
    }

    this.fn_setHomePage(props);

    if (searchParams.get('hideMenu') !== null) {
      localStorage.setItem("hideMenu", searchParams.get('hideMenu'));
    } else {
      localStorage.setItem("hideMenu", "");
    }
  },

  /**
   * @description Controlla se la sessione è ancora valida e in caso contrario resetta la sessione
   */
  fn_checkSession: function fn_checkSession() {
    // Reset when storage is more than 24hours
    //var hours = 24; 
    var now = new Date().getTime();
    var setupTime = localStorage.getItem('setupTime');

    if (setupTime != null) {
      //if(now-setupTime > hours*60*60*1000) {
      if (now - setupTime > 2 * 60 * 1000) {
        this.fn_logout(null);
      }
    }
  },

  /**
  * @description Ritorna l'informazione se sono state settate le credenziali in background
  */
  fn_credentialInBackground: function fn_credentialInBackground() {
    return localStorage.getItem("getUsername") !== undefined && localStorage.getItem("getUsername") !== null && localStorage.getItem("getUsername") !== "null" && localStorage.getItem("getUsername") !== "" && localStorage.getItem("getPassword") !== undefined && localStorage.getItem("getPassword") !== null && localStorage.getItem("getPassword") !== "null" && localStorage.getItem("getPassword") !== "";
  },

  /**
   * @description Ritorna l'informazione se l'utente è loggato o meno 
   */
  fn_isLogged: function fn_isLogged() {
    return localStorage.getItem("utenteId") !== undefined && localStorage.getItem("utenteId") !== null && localStorage.getItem("utenteId") !== "null" && localStorage.getItem("utenteId") !== "";
  },

  /**
   * @description Ritorna l'informazione se il login è da gestionale o meno
   */
  fn_isGestionale: function fn_isGestionale() {
    return localStorage.getItem("loginGestionale") !== undefined && localStorage.getItem("loginGestionale") !== null && localStorage.getItem("loginGestionale") !== "null" && localStorage.getItem("loginGestionale") !== "";
  },

  /**
   * @description Ritorna l'informazione se il menù è da visualizzare o meno
   */
  fn_hideMenu: function fn_hideMenu() {
    return localStorage.getItem("hideMenu") !== undefined && localStorage.getItem("hideMenu") !== null && localStorage.getItem("hideMenu") !== "null" && localStorage.getItem("hideMenu") !== "";
  },

  /**
   * @description Ritorna l'informazione se il cliente è settato o meno
   */
  fn_isSetCliente: function fn_isSetCliente() {
    return localStorage.getItem("loginIdCliente") !== undefined && localStorage.getItem("loginIdCliente") !== null && localStorage.getItem("loginIdCliente") !== "null" && localStorage.getItem("loginIdCliente") !== "";
  },

  /**
   * @description Ritorna l'informazione se lo screen è bloccato o meno 
   */
  fn_isLockScreen: function fn_isLockScreen() {
    return localStorage.getItem("loginGestionale") !== undefined && localStorage.getItem("lockScreen") !== null && localStorage.getItem("lockScreen") !== "null" && localStorage.getItem("lockScreen") === "true";
  },

  /**
   * @description Ritorna l'uuid dell'utente loggato: USARE NON SU BELINK
   */
  fn_getUserUuid: function fn_getUserUuid() {
    return localStorage.getItem("utenteId");
  },

  /**
  * @description Ritorna l'id dell'utente loggato: USARE SU BELINK
  */
  fn_getUtenteId: function fn_getUtenteId() {
    return localStorage.getItem("utenteId");
  },

  /**
  * @description Ritorna l'accesso dell'utente loggato: USARE SU BELINK
  */
  fn_getAccessoId: function fn_getAccessoId() {
    return localStorage.getItem("accessoId");
  },

  /**
  * @description Ritorna l'uuid del soggetto legato all'accesso
  */
  fn_getUuidSoggetto: function fn_getUuidSoggetto() {
    return localStorage.getItem("registryId");
  },

  /**     
   * @description Ritorna l'email dell'utente loggato
   */
  fn_getUserEmail: function fn_getUserEmail() {
    return localStorage.getItem("utenteEmail");
  },

  /**    
   * @description Ritorna il token dell'utente loggato
   */
  fn_getUserToken: function fn_getUserToken() {
    return localStorage.getItem("tokenKey");
  },

  /**     
   * @description Ritorna l'uuid del contatto dell'utente loggato
   */
  fn_getUserContact: function fn_getUserContact() {
    var contatto = localStorage.getItem("utenteContatto");
    if (contatto == null || contatto == undefined || contatto == "null") contatto = "";
    return contatto;
  },

  /**     
   * @description Ritorna il nome dell'utente loggato
   */
  fn_getUserNomeUtente: function fn_getUserNomeUtente() {
    return localStorage.getItem("utenteNome");
  },

  /**
   * @description Ritorna l'uuid del cliente loggato
   */
  fn_getClienteUuid: function fn_getClienteUuid() {
    return localStorage.getItem("loginIdCliente");
  },

  /**
   * @description Ritorna lo username settato via get
   */
  fn_getUsernameGet: function fn_getUsernameGet() {
    return localStorage.getItem("getUsername");
  },

  /**
   * @description Ritorna lo username in sessione
   */
  fn_getUsername: function fn_getUsername() {
    return localStorage.getItem("username");
  },

  /**
   * @description Ritorna la password settata via get
   */
  fn_getPasswordGet: function fn_getPasswordGet() {
    return localStorage.getItem("getPassword");
  },

  /**
   * @description Ritorna la home page settata via get
   */
  fn_setHomePage: function fn_setHomePage(props) {
    /*** 239989 ***/
    var searchParams = new URLSearchParams(props.location.search);

    if (searchParams.get('homePage') !== null) {
      localStorage.setItem("getHomePage", searchParams.get('homePage'));
    } else {
      localStorage.setItem("getHomePage", "");
    } // const queryString = require('query-string');
    // let queryStringParam = queryString.parse(props.location.search);  
    // if(queryStringParam["homePage"]!=undefined){
    //     localStorage.setItem("getHomePage", queryStringParam["homePage"]);
    // }        
    // else{
    //     localStorage.setItem("getHomePage", "");
    // }

  },

  /**
   * @description Ritorna la home page settata via get
   */
  fn_getHomePage: function fn_getHomePage() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var homePage;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              homePage = localStorage.getItem("getHomePage");

              if (!(homePage === "" || homePage === null || homePage === undefined)) {
                _context2.next = 5;
                break;
              }

              _context2.next = 4;
              return _service.default.getHomePage();

            case 4:
              homePage = _context2.sent;

            case 5:
              return _context2.abrupt("return", homePage);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * @description Ritorna il logo dell'utente loggato
   */
  fn_getUserLogo: function fn_getUserLogo() {
    if (localStorage.getItem("logo") !== null) {
      return JSON.parse(localStorage.getItem("logo"));
    } else {
      return "";
    }
  }
};
exports.default = _default;